import { Component, OnInit } from '@angular/core';
import { CarrierStatRow, KPIDashboardService } from '../kpidashboard.service';

@Component({
  selector: 'sa-carrier-stats',
  styleUrls: ['./carrier-stats.component.scss'],
  templateUrl: './carrier-stats.component.html',
})
export class CarrierStatsComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public timeframe = 30;
  public medians = [0.5, 0.75, 0.95];
  public median = this.medians[0];
  public loading = false;
  public dataSource: CarrierStatRow[];
  public displayedColumns: string[] = [
    'carrierName',
    'averageDispatchTime',
    'totalLoadsUpForGrabsOrMissed',
    'averageCompletionTime',
    'uniqueDrivers',
  ];

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.fetchCarriersStats();

    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      const resolvedRegionID = regionID || 0;

      this.regionID = resolvedRegionID;
      this.fracsID = resolvedRegionID === 0 ? [] : this.fracsID;
      this.fetchCarriersStats();
    });

    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.fracsID = fracsID;
        this.fetchCarriersStats();
      }
    });
  }

  private fetchCarriersStats(): void {
    this.loading = true;
    const carrierStatsTimeframe = this.kpiDashboardService.getLocalStorage('carrier_stats_timeframe');
    if (carrierStatsTimeframe) {
      this.timeframe = carrierStatsTimeframe;
    }

    const carrierStatsMedian = this.kpiDashboardService.getLocalStorage('carrier_stats_median');
    if (carrierStatsMedian) {
      this.median = carrierStatsMedian;
    }
    this.kpiDashboardService.getCarriersStats$(this.regionID, this.median, this.fracsID, this.timeframe).subscribe(
      (data) => {
        this.dataSource = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  public onTimeframeChange(timeframe: number) {
    this.timeframe = timeframe;
    this.kpiDashboardService.setLocalStorage('carrier_stats_timeframe', this.timeframe);
    this.fetchCarriersStats();
  }

  public onMedianChange(median: number) {
    this.median = median;
    this.kpiDashboardService.setLocalStorage('carrier_stats_median', this.median);
    this.fetchCarriersStats();
  }
}
